export const PERMISSION_LIST_REQUEST = 'PERMISSION_LIST_REQUEST'
export const PERMISSION_LIST_SUCCESS = 'PERMISSION_LIST_SUCCESS'
export const PERMISSION_LIST_FAIL = 'PERMISSION_LIST_FAIL'
